import type { Schedulable } from '@empathyco/playboard-core-domain'
import { getCurrentInstance } from 'vue'
import { useDateFormat } from './use-date-format'

export function useScheduleFormat(schedule: Schedulable['schedule']): string {
  const ctx = getCurrentInstance()
  if (!ctx) {
    throw new Error("'ctx' is not defined")
  }
  const {
    proxy: { $epb },
  } = ctx

  const scheduleTextItems: string[] = []
  const scheduleMessages = $epb.messages.crud.schedule

  if (schedule.activationDate) {
    const activationDateString = $epb.utils.compileMessage(scheduleMessages.from, {
      date: useDateFormat(schedule.activationDate),
    })
    scheduleTextItems.push(activationDateString)
  }
  if (schedule.deactivationDate) {
    const deactivationDateString = $epb.utils.compileMessage(scheduleMessages.to, {
      date: useDateFormat(schedule.deactivationDate),
    })
    scheduleTextItems.push(deactivationDateString)
  }
  if (!scheduleTextItems.length) {
    return scheduleMessages.always
  }
  return scheduleTextItems.join('<br>')
}
